import { useSections } from '../../context/site-content.context';
import { createElementId } from '../../helpers/content.helper';
import { AlternateVariant } from '../../models/component.model';
import { ContentWrapper } from '../collections/ContentWrapper';
import { SectionContentDisplay } from '../sections/SectionContentDisplay';

interface Props {
    before?: React.ReactNode;
    item: AlternateVariant;
    contentClassName?: string;
}

export const AlternateVariantDisplay = ({
    item,
    contentClassName,
    before,
}: Props): React.ReactElement<any, any> | null => {
    const sections = useSections(item.id);

    const contentClassNameInner = contentClassName
        ? contentClassName + ' alternate-variant-display'
        : 'alternate-variant-display';

    return (
        <>
            {sections.map((section, index) => {
                const isEven = index % 2 === 0;
                const id = createElementId(section.id);

                return (
                    <ContentWrapper id={id} key={id} contentClassName={contentClassNameInner}>
                        <SectionContentDisplay
                            before={index === 0 && before}
                            textSize={item.options?.textSize}
                            imageSize={item.options?.imageSize}
                            content={section}
                            reverse={!isEven}
                        />
                    </ContentWrapper>
                );
            })}
        </>
    );
};
